import config from '../../config';

const ON = 'health-on.png';
const OFF = 'health-off.png';
const FLASH = 'health-flash.png';

class Health extends Phaser.GameObjects.Group {
  constructor (gameContext) {
    super(gameContext.sys.scene, []);
    let group = this;
    let g = gameContext;

    g.sys.updateList.add(group);

    let healthIcons = [];
    let icon = group.create(40, config.HEIGHT - 200, 'hero');
    icon.isFilled = true;
    icon.setFrame(ON);
    healthIcons.push(icon);
    icon = group.create(40, config.HEIGHT - 125, 'hero');
    icon.isFilled = true;
    icon.setFrame(ON);
    healthIcons.push(icon);
    icon = group.create(40, config.HEIGHT - 50, 'hero');
    icon.isFilled = true;
    icon.setFrame(ON);
    healthIcons.push(icon);

    _.each(healthIcons, (icon) => {
      let flash = group.create(icon.x, icon.y, 'hero');
      flash.setFrame(FLASH);
      flash.alpha = 0;
      icon.flash = flash;
    });

    group.assets = { healthIcons };
  }
  get filled () {
    let group = this;
    let { healthIcons } = group.assets;
    let filled = 0;
    _.each(healthIcons, (icon) => {
      if (icon.isFilled) {
        filled++;
      }
    });
    return filled;
  }
  drain () {
    // console.log('Health.drain');
    let group = this;
    let g = group.scene;
    let { healthIcons } = group.assets;
    for (let icon of healthIcons) {
      if (icon.isFilled) {
        icon.setFrame(OFF);
        icon.isFilled = false;
        g.tweens.add({
          targets: icon.flash,
          alpha: 1,
          yoyo: true,
          repeat: 10,
          duration: 45
        });
        return;
      }
    }
  }
  fillAll () {
    let group = this;
    let g = group.scene;
    let { healthIcons } = group.assets;
    for (let icon of healthIcons) {
      if (!icon.isFilled) {
        icon.setFrame(ON);
        icon.isFilled = true;
        g.tweens.add({
          targets: icon.flash,
          alpha: 1,
          yoyo: true,
          repeat: 10,
          duration: 100
        });
      }
    }
  }
}

export default Health;
